import styled from "styled-components"

import { Select } from "antd"

const SelectStyled = styled(Select)`
  width: ${(props) => props?.width};
`

export default SelectStyled
